import React, { Component } from 'react'
import Select, { Creatable, Async } from 'react-select';
import { SingleDatePicker } from 'react-dates'
import classNames from 'classnames';
import Search from "./search"
import { api } from 'api';
import { TIPO_VEHICULO } from '../../../../utility/constants';

let DIAS = [
    {id: 1, value: 1, label:"1"},
    {id: 2, value: 2, label:"2"},
    {id: 3, value: 3, label:"3"},
    {id: 4, value: 4, label:"4"},
    {id: 5, value: 5, label:"5"},
    {id: 6, value: 6, label:"6"},
    {id: 7, value: 7, label:"7"},
    {id: 8, value: 8, label:"8"},
    {id: 9, value: 9, label:"9"},
    {id: 10, value: 10, label:"10"},
    {id: 11, value: 11, label:"11"},
    {id: 12, value: 12, label:"12"},
    {id: 13, value: 13, label:"13"},
    {id: 14, value: 14, label:"14"},
    {id: 15, value: 15, label:"15"},
    {id: 16, value: 16, label:"16"},
    {id: 17, value: 17, label:"17"},
    {id: 18, value: 18, label:"18"},
    {id: 19, value: 19, label:"19"},
    {id: 20, value: 20, label:"20"},
    {id: 21, value: 21, label:"21"},
    {id: 22, value: 22, label:"22"},
    {id: 23, value: 23, label:"23"},
    {id: 24, value: 24, label:"24"},
    {id: 25, value: 25, label:"25"},
    {id: 26, value: 26, label:"26"},
    {id: 27, value: 27, label:"27"},
    {id: 28, value: 28, label:"28"},
    {id: 29, value: 29, label:"29"},
    {id: 30, value: 30, label:"30"},
    {id: 31, value: 31, label:"31"}
]

const getMaquinariaVehiculos = (search) => {
    let params = {};
    params.tipo = TIPO_VEHICULO;
    params.search = search;
    // params.page = 1;

    return api.get("vehiculos", params).
        then((data) => {
            if (data) return data.results;
            return [];
        }).catch(() => {
            return [];
        });
};

export default class ToolbarReporteVehiculos extends Component {
    state = {
        focusedStart: false,
        focusedEnd: false,
    }

    componentWillMount() {
        let resultados = getMaquinariaVehiculos('')
    }

    format = (array=[]) =>{
        const nuevoArray = [];
        array.forEach((item,index) => {
            nuevoArray[index]={"label": item.nombre , "value": item.id}
        });
        return nuevoArray
    }

    render() {
        const { vehiculo, fecha_inicio, fecha_fin, empresas, changeEmpresa } = this.props;
        return (
            <div className="row col-12 p-0">
                <div className="row col-12 m-0 text-lg-left justify-content-end">
                    <div className={"col-lg-4 col-md-4 col-12 align-self-center"}>
                        <span className="t-azul-claro font-weight-bold">Vehículo</span>
                        <Async
                            isClearable={true}
                            backspaceRemovesValue={false}
                            value={vehiculo}
                            isSearchable={true}
                            loadOptions={getMaquinariaVehiculos}
                            getOptionValue={(option) => (option["id"])}
                            getOptionLabel={(option) => (option["nombre"])}
                            type="text"
                            onChange={(e) => this.props.changeVehiculo(e)}
                            multi={true}
                            autoload={false}
                            cache={false}
                            className={classNames('react-select-container ')}
                            defaultOptions={true}
                            placeholder="Seleccionar.."
                        />
                    </div>
                    <div className={"col-lg-4 col-md-3 col-12 align-self-center"}>
                        <span className="t-azul-claro font-weight-bold">Empresa</span>
                        <Select
                            isClearable={true}
                            className={classNames('react-select-container')}
                            backspaceRemovesValue={true}
                            isSearchable={true}
                            options={this.format(empresas? empresas:[])}
                            placeholder={"Empresa"}
                            // value={null}
                            onChange={(e, action)=>{console.log(e, action); changeEmpresa(e)}}
                        />
                    </div>
                    <div className={"col-lg-2 col-md-4 col-12 align-self-center"}>
                        <span className="t-azul-claro font-weight-bold">Fecha Inicial</span>
                        <SingleDatePicker
                            // className="form-control"
                            placeholder={"Fecha Inicio"}
                            date={fecha_inicio ? fecha_inicio : null}
                            focused={this.state.focusedStart}
                            isOutsideRange={() => false}
                            onDateChange={(value) => {
                                this.props.changeFechaInicio(value)
                            }}
                            onFocusChange={({ focused }) => this.setState({ focusedStart: focused })}
                            numberOfMonths={1}
                            id={"dateStart"}
                            readOnly={true}
                        />
                    </div>
                    <div className={"col-lg-2 col-md-4 col-12 align-self-center"}>
                        <span className="t-azul-claro font-weight-bold">Fecha Final</span>
                        <SingleDatePicker
                            // className="form-control"
                            placeholder={"Fecha Final"}
                            date={fecha_fin ? fecha_fin : null}
                            focused={this.state.focusedEnd}
                            isOutsideRange={() => false}
                            onDateChange={(value) => {
                                this.props.changeFechaFin(value)
                            }}
                            onFocusChange={({ focused }) => this.setState({ focusedEnd: focused })}
                            numberOfMonths={1}
                            id={"dateEnd"}
                            readOnly={true}
                        />
                    </div>

                    <div className={"col-lg-2 col-md-4 col-12 pt-2 align-self-center"}>
                        <span className="t-azul-claro font-weight-bold">Día de pago</span>
                        <Select
                            isClearable={true}
                            className={classNames('react-select-container')}
                            backspaceRemovesValue={false}
                            isSearchable={true}
                            options={DIAS}
                            placeholder={"Día"}
                            defaultValue={this.props.dias}
                            value={this.props.dias}
                            onChange={this.props.changeDias}
                        />
                    </div>

                    {(this.props.buscar !== undefined) && (
                        <div className={"col-lg-4 col-md-4 col-12 pt-2 align-self-center"}>
                            <span>&nbsp;</span>
                            <Search buscar={this.props.buscar} buscador={this.props.buscador} placeholder={this.props.placeholder} />
                        </div>
                    )}

                </div>
            </div>
        )
    }
}
